<template>
  <div>
    <modal v-model="showModal" size="lg">
      <div class="modal-outer-container">
        <div class="consent-modal-header">
          <span class="consent-modal-title">Attachments</span>
          <button class="btn border-0" @click="closeModal">
            <i class="fas fa-times fa-lg"></i>
          </button>
        </div>
      </div>
      <div class="p-2">
        <div class="scrollable-content">
          <alert v-if="attachments.length == 0" class="m-4">
            No Attachments to Show
          </alert>
          <table v-else class="table table-striped border-top-0">
            <tbody>
              <tr>
                <th>Icon</th>
                <th><span class="desktop-only">Name</span></th>
                <th class="desktop-only">Size</th>
                <th class="desktop-only"></th>
              </tr>
              <tr v-for="attachment in attachments" :key="attachment.id">
                <td>
                  <icon
                    :type="
                      getFileTypeByExtension(attachment)
                        ? `file-${getFileTypeByExtension(attachment)}`
                        : 'file'
                    "
                    class="fa-2x text-muted m-0"
                  />
                </td>
                <td>
                  {{ attachment.original_file_name }}
                  <br />
                  <span v-if="attachment.created_at">
                    <span class="text-right text-muted small">
                      {{ prettyDate(attachment.created_at) }}
                    </span>
                    <br />
                  </span>
                  <b class="mobile-tablet-only mr-2">Size:</b>
                  <span class="small text-muted mobile-tablet-only">
                    {{ attachment.readable_size }}
                  </span>
                  <div class="mobile-tablet-only">
                    <div class="mb-3 mt-2">
                      <button
                        v-if="canViewFile(attachment)"
                        @click="viewFile(attachment)"
                        class="btn btn-sm btn-theme mt-2"
                      >
                        View
                      </button>
                      <button
                        @click="downloadFile(attachment)"
                        class="btn btn-sm btn-black mt-2 ml-2"
                      >
                        Download
                      </button>
                    </div>
                  </div>
                </td>
                <td class="desktop-only">
                  <span class="small text-muted">{{
                    attachment.readable_size
                  }}</span>
                </td>
                <td class="text-right desktop-only">
                  <button
                    v-if="canViewFile(attachment)"
                    @click="viewFile(attachment)"
                    class="btn btn-sm btn-theme mt-2"
                  >
                    View
                  </button>
                  <button
                    @click="downloadFile(attachment)"
                    class="btn btn-sm btn-black mt-2 ml-2"
                  >
                    Download
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </modal>
    <file-viewer
      v-model="showFileViewerModal"
      :name="selectedAttachment.name"
      :type="selectedAttachment.type"
      :link="selectedAttachment.link"
    />
  </div>
</template>
<script>
import helpers from "@/utils/helpers";

export default {
  props: {
    consent: {
      type: Object,
      required: true,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      showFileViewerModal: false,
      selectedAttachment: {
        name: "",
        type: "",
        link: "",
      },
    };
  },
  computed: {
    attachments() {
      return this.consent?.attachments || [];
    },
    showModal: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    getFileTypeByExtension: (attachment) =>
      helpers.getFileTypeByExtension(attachment.extension),
    canViewFile: function (attachment) {
      const allowedExtensions = [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "jpg",
        "jpeg",
        "png",
      ];
      return allowedExtensions.includes(attachment.extension);
    },
    viewFile: function (attachment) {
      this.selectedAttachment = {
        name: attachment.original_file_name,
        type: this.getFileTypeByExtension(attachment),
        link: attachment.path,
      };
      setTimeout(() => {
        this.showFileViewerModal = true;
      });
    },
    downloadFile: function (attachment) {
      window.open(attachment.path, "_blank");
    },
    prettyDate: function (date) {
      return helpers.prettyDate(date);
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.scrollable-content {
  max-height: 400px;
  overflow-y: auto;
}

.consent-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e3ebf6;
}

.consent-modal-title {
  font-size: 1rem;
  font-weight: 600;
}
</style>
